import { Question } from "@common";
import ConditionalWrapper from "../components/ConditionalWrapper";
import Fade from "../components/Fade";

const ConditionalFade: React.FC<{
  children: React.ReactElement;
  fadeInAnimation?: boolean;
  contentFadeDelay: number;
  currQuestion: Question;
}> = ({ children, fadeInAnimation, contentFadeDelay, currQuestion }) => {
  return (
    <ConditionalWrapper
      condition={fadeInAnimation}
      wrapper={(wChildren: any) => (
        <Fade delay={contentFadeDelay} {...currQuestion.renderProps}>
          {wChildren}
        </Fade>
      )}
    >
      {children}
    </ConditionalWrapper>
  );
};

export default ConditionalFade;
